import * as GS from 'styles/globalStyles';

const GenericModal = ({ children }) => <GS.Container>{children}</GS.Container>;

export default GenericModal;
